<template functional>
  <div class="row mx-0 mb-2">
    <div
      class="col-10 rounded-lg"
      :class="'alert-' + props.variant"
      style="box-shadow: 2px 2px 2px;">
      <div class="tooltip-caret-left" v-if="props.alternate">
        <i class="fa fa-caret-left"></i>
      </div>
      <div class="tooltip-caret-right" v-else>
        <i class="fa fa-caret-right"></i>
      </div>

      <div class="font-weight-bold">{{ props.user }}</div>
      <div style="overflow-x: auto;">
        <p class="m-0 p-0" v-for="l in $options.splitText(props.text)" :key="l">{{ l }}</p>
      </div>
      <div class="text-right"><small>{{ props.timestamp }}</small></div>
    </div>
    <div
      class="col-2 align-self-center"
      :class="{
        'order-first text-right pl-0': props.alternate,
        'pr-0': !props.alternate
      }">
      <i class="fa fa-fw fa-user"></i>
    </div>
  </div>
</template>
<style>
.tooltip-caret-right {
  position: absolute;
  top: 50%;
  left: 100%; /* To the left of the tooltip */
  margin-top: -0.5em;
}

.tooltip-caret-left {
  position: absolute;
  top: 50%;
  right: 100%; /* To the left of the tooltip */
  margin-top: -0.5em;
}
</style>
<script>
export default {
  functional: true,

  props: {
    alternate: {
      type: Boolean,
      default: false
    },

    user: {
      type: String,
      required: true
    },

    text: {
      type: String,
      required: true,
    },

    timestamp: {
      type: String,
      required: true
    },

    variant: {
      type: String,
      default: 'primary'
    }
  },

  splitText(text) {
    return text.split(/\r?\n/);
  },
};
</script>
